module.exports = __webpack_public_path__ + "img/LT.83502de2.png";